import React from "react";
import { Button, Navbar, Nav } from "react-bootstrap";
import { Link } from "gatsby";

import logo from "../../images/logo.svg";
import { appStoreUrl } from '../../constants'

const Header = () => (
  <div className="container">
    <Navbar as="header" expand="lg" className="justify-content-between">
      <Navbar.Brand as={Link} to="/" className="align-middle">
        <img className="mr-2" src={logo} width="30" height="30" alt="" />
        Tramo
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-md-auto">
          <Nav.Link
            as={Link}
            to="/privacy-policy"
            className="mr-0 mr-lg-4 text-center"
          >
            Privacy Policy
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/terms-of-use"
            className="mr-0 mr-lg-4 text-center"
          >
            Terms of Use
          </Nav.Link>
          <Button href={appStoreUrl} variant="outline-success">Download</Button>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  </div>
);

export default Header;
